export default "__VITE_ASSET__CGiXZ$wq__"